// extracted by mini-css-extract-plugin
export var header = "_u5-1";
export var maskBottom = "_u5-6";
export var maskMiddle = "_u5-7";
export var maskTop = "_u5-5";
export var root = "_u5-0";
export var scrollDownButton = "_u5-3";
export var scrollDownButtonHidden = "_u5-4";
export var viewport = "_u5-2";